import { sistemaNameSSO } from '../config/system';

export function utf8_to_b64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}

export function b64_to_utf8(str) {
  return decodeURIComponent(escape(window.atob(str)));
}

export function reverseString(str = '') {
  return str.split('').reverse().join('');
}

export function getEncodeAvatarUsuario(cpf, size) {
  return reverseString(utf8_to_b64(reverseString(utf8_to_b64(cpf + '_' + new Date().getTime() + (size ? size : '_80')))));
}

function isNumeric(num) {
  return !isNaN(num);
}

function splitLastOccurrence(text, splited) {
  return text.substr(0, text.lastIndexOf(splited));
}

export function getDateFormatInputHtmlDateTime(timestamp) {
  if (timestamp) {
    if (isNumeric(timestamp)) timestamp = parseInt(timestamp);
    return splitLastOccurrence(new Date(timestamp).toJSON(), 'T') + 'T' + splitLastOccurrence(new Date(timestamp).toLocaleTimeString(), ':');
  }
}

export function getDateFormatInputHtmlDate(timestamp) {
  if (timestamp) {
    if (isNumeric(timestamp)) timestamp = parseInt(timestamp);
    return splitLastOccurrence(new Date(timestamp).toJSON(), 'T');
  }
}

// export function getFormatDateTime(timestamp) {
// 	if (timestamp) {
// 		if (isNumeric(timestamp)) timestamp = parseInt(timestamp);
// 		return (
// 			new Date(timestamp).toLocaleDateString() +
// 			' ' +
// 			splitLastOccurrence(new Date(timestamp).toLocaleTimeString(), ':')
// 		);
// 	}
// }

// export function getFormatDate(timestamp) {
// 	if (timestamp) {
// 		if (isNumeric(timestamp)) timestamp = parseInt(timestamp);
// 		return new Date(timestamp).toLocaleDateString();
// 	}
// }

export function setCaretAtEnd(elem) {
  var elemLen = elem.value.length;
  if (document.selection) {
    elem.focus();
    var oSel = document.selection.createRange();
    oSel.moveStart('character', -elemLen);
    oSel.moveStart('character', elemLen);
    oSel.moveEnd('character', 0);
    oSel.select();
  } else if (elem.selectionStart || elem.selectionStart == '0') {
    elem.selectionStart = elemLen;
    elem.selectionEnd = elemLen;
    elem.focus();
  }
}

export function mobileAndTabletCheck() {
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export function encrypt(data, key) {
  try {
    let dataEncrypeted = data;
    key.length.map(() => {
      dataEncrypeted = utf8_to_b64(reverseString(dataEncrypeted));
    });
    return dataEncrypeted;
  } catch (error) {
    //console.error(error);
  }
  return data;
}

export function decrypt(data, key) {
  try {
    let dataDecrypted = data;
    key.length.map(() => {
      dataDecrypted = reverseString(b64_to_utf8(dataDecrypted));
    });
    return dataDecrypted;
  } catch (error) {
    //console.error(error);
  }
  return data;
}

export function setTokenSSO(token) {
  const tokenEncrypted = encrypt(token, sistemaNameSSO);
  window.localStorage.setItem('token', tokenEncrypted);
}

export function getTokenSSO() {
  const tokenEncrypted = window.localStorage.getItem('token');
  return decrypt(tokenEncrypted, sistemaNameSSO);
}

export function setDataUser(dataUser) {
  const dataUserEncrypted = encrypt(JSON.stringify(dataUser), sistemaNameSSO);
  window.dataUser = dataUserEncrypted;
}

export function getDataUser() {
  const dataUserEncrypted = window.dataUser;
  let dataUser = JSON.parse(decrypt(dataUserEncrypted, sistemaNameSSO));
  if (!dataUser) dataUser = {};
  return dataUser;
}

export function setModuloMenuSelecionado(menuSelecionado) {
  const menuSelecionadoEncrypted = encrypt(menuSelecionado, sistemaNameSSO);
  window.localStorage.setItem('menuSelecionado', menuSelecionadoEncrypted);
}

export function getModuloMenuSelecionado() {
  const menuSelecionadoEncrypted = window.localStorage.getItem('menuSelecionado');
  if (menuSelecionadoEncrypted === undefined || menuSelecionadoEncrypted === null) {
    return undefined;
  }
  return decrypt(menuSelecionadoEncrypted, sistemaNameSSO);
}

export function removerModuloMenuSelecionado() {
  window.localStorage.removeItem('menuSelecionado');
}

export function validarMenus(menus, nomeMenu) {
  document.getElementById('sider-bar').style.display = 'block';
  menus.forEach((menu) => {
    if (menu.menu) {
      document.getElementById('sider-bar').style.display = 'block';
      if (nomeMenu === 'CONFIGURAÇÕES') {
        if (menu.uniqueKey === 'configuracoes-menu' || menu.uniqueKey === 'home' || menu.uniqueKey === 'secretaria') {
          document.getElementById('configuracoes-menu').style.display = 'block';
          document.getElementById('alterar-modulo').style.display = 'block';
          document.getElementById('secretaria').style.display = 'block';
        } else if (menu.uniqueKey) {
          document.getElementById(menu.uniqueKey).style.display = 'none';
        }
      } else if (nomeMenu === 'PSICOLOGIA') {
        if (menu.uniqueKey === 'secretaria' || menu.uniqueKey === 'configuracoes-menu') {
          document.getElementById('secretaria').style.display = 'none';
          document.getElementById('configuracoes-menu').style.display = 'none';
        } else if (menu.uniqueKey) {
          document.getElementById(menu.uniqueKey).style.display = 'block';
        }
      } else {
        if (menu.uniqueKey === 'configuracoes-menu') {
          document.getElementById('configuracoes-menu').style.display = 'none';
        } else {
          document.getElementById(menu.uniqueKey).style.display = 'block';
        }
      }
    }
  });
}

// export function sleep(time) {
// 	return new Promisse((resolve, reject) => {
// 		setTimeout(() => {
// 			resolve();
// 		}, time);
// 	});
// }

// export function groupBy(array, fieldGroup) {
// 	const groupBy = (prop) => (data) => {
// 		return data.reduce((dict, item) => {
// 			const { [prop]: _, ...rest } = item;
// 			dict[item[prop]] = [...(dict[item[prop]] || []), rest];
// 			return dict;
// 		}, {});
// 	};
// 	return Object.entries(groupBy(fieldGroup)(array)).map(([key, value]) => ({
// 		name: key,
// 		children: value,
// 	}));
// }
//
// export function dynamicSort(property) {
// 	var sortOrder = 1;
// 	if (property[0] === '-') {
// 		sortOrder = -1;
// 		property = property.substr(1);
// 	}
// 	return function (a, b) {
// 		var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
// 		return result * sortOrder;
// 	};
// }
//
// export function normalizeObjectJsonAndReturnJsonString(objP, removeProperties) {
// 	const obj = { ...objP };
//
// 	if (removeProperties) {
// 		removeProperties.forEach((field) => {
// 			if (field) delete obj[field];
// 		});
// 	}
// 	return JSON.stringify(obj, Object.keys(obj).sort(), 3);
// }
